





































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import GoodsApi from '@/api/goods/list/index'
import AbpBase from '@/lib/abpbase'
import activityApi from '@/api/marketing/promotionActivity/index'
import CustomForm from '@/components/custom-form/index.vue'
@Component({
  components: { CustomForm },
})
export default class OutfitSelect extends AbpBase {
  /**
   * limitDiscount 限时折扣
   * preSales 预售
   * group 拼团
   * secKill 秒杀
   * buyGetOne 满X件免一
   * tierDiscount 满减满折
   * freeShipping 满包邮
   */
  @Prop({ type: String, default: null })
  activityType: string

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true,
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false,
  })
  show!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []

  filters = [
    {
      type: 'input',
      props: {
        placeholder: '活动名称',
        
      },
      width: 180,
      key: 'keyWord',
    },
  ]

  columns: any[] = [
    {
      title: '套装活动名称',
      key: 'name',
      align: 'center',
    },
    // {
    //   title: '活动类型',
    //   key: 'activityTypeDisplayName',
    //   align: 'center',
    // },
    // {
    //   title: '活动开始时间',
    //   slot: 'beginTime',
    //   align: 'center',
    // },
    // {
    //   title: '活动结束时间',
    //   slot: 'endTime',
    //   align: 'center',
    // },
    // {
    //   title: '活动状态',
    //   key: 'activityStatus',
    //   align: 'center',
    // },
  ]

  async mounted() {}
  @Watch('modal1')
  async modalShowChange(show) {
    if (show) await this.getPageList()
  }

  async getPageList() {
    let form: any = this.$refs.lineForm
    const formData = (form && form.getForm()) || { keyWord: '' }
    await activityApi
      .getActivityList(
        this.pageSize,
        this.pageIndex,
        this.activityType,
        formData.keyWord,
        undefined,
        1,
        true
      )
      .then((res) => {
        this.total = res.data.totalCount
        this.data = res.data.items
      })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.getPageList()
  }

  submitChange(form, valid) {
    if (valid) {
      this.getPageList()
    }
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  promotionId: string = ''
  name: string = ''
  promotionOutfitConfig: any[] = []
  currentChange(currentRow, oldCurrentRow) {
    if (currentRow.activityStatus != '活动已下架') {
      // this.$emit('on-row-selected', currentRow)
      console.log('currentRow', currentRow)
      // this.modal1 = false
      this.promotionId = currentRow.id
      this.name = currentRow.name
      this.promotionOutfitConfig = currentRow.promotionOutfitConfig
      // var temp = []
      // for (var i = 0; i < 20; i++) {
      //   temp = temp.concat(currentRow.promotionOutfitConfig)
      // }
      // this.promotionOutfitConfig = temp
    } else {
      this.$Notice.warning({
        desc: '不能选择已下架的活动',
      })
    }
  }

  selectOutfit(item) {
    this.$emit('on-row-selected', item, this.promotionId, this.name)
    this.modal1 = false
  }

  cancelFn() {
    this.$emit('on-row-selected', null)
    this.modal1 = false
  }
}
